import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { MediaMetadataGridContainer, MediaMetadataGridItem } from "../../media-metadata/grid/MediaMetadataGrid";
import { Typography } from "@kaltura/ds-react-components";
import { MediaAttachment } from "./MediaAttachment";
import { KmsTypeMediaAttachment } from "./KmsTypeMediaAttachment";

export interface MediaAttachmentsProps {
    attachments: KmsTypeMediaAttachment[];
    title: string;
}

const StyledContainer = styled(Box)(({ theme }) => ({
    backgroundColor: theme.kaltura.palette.surfaces.background,
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

/**
 * Media attachments
 */
export const MediaAttachments = ({ attachments, title }: MediaAttachmentsProps) => {
    if (!attachments?.length) {
        return null;
    }

    return (
        <StyledContainer className="kms-ds-media-page-moduledata-attachments">
            <StyledTitle
                variant={"body1Highlight"}
                paragraph
                className="kms-ds-media-page-moduledata-attachments-title"
            >
                {title}
            </StyledTitle>

            <MediaMetadataGridContainer>
                {attachments.map((attachment, index) => (
                    <MediaMetadataGridItem key={index}>
                        <MediaAttachment key={index} {...attachment} />
                    </MediaMetadataGridItem>
                ))}
            </MediaMetadataGridContainer>
        </StyledContainer>
    );
};

export default MediaAttachments;
